import React from "react";
import { Button } from "../ui/button";
import { useLanguage } from "../../App";

const CharacterActionBar = ({ onConfirm, disabled, label }) => {
  const { language } = useLanguage();
  const isEnglish = language === "en";
  return (
    <div className="px-4 py-3">
      <Button className="w-full h-10" disabled={disabled} onClick={onConfirm}>
        {label || (isEnglish ? "Choose Character" : "Pilih Karakter")}
      </Button>
    </div>
  );
};

export default CharacterActionBar;
